export interface GridViewColumnLinkDataModel {
    url: string;
    keys: string[];
    values: string[];
}

export interface GridViewColumnModel {
    label: string;
    name: string;
    isSortable: boolean;
    valueIfTrue?: string;
    valueIfFalse?: string;
    classHeader?: string;
    classBody?: string;
    width?: string;
    type: string;
    linkData?: GridViewColumnLinkDataModel;
}
